import { connect } from 'react-redux';
import Header from '../components/shared/Header/Header';
import { closeModalActions } from '../stores/closeModal/closeModalActions';

const mapDispatchToProps = {
  closeModalOpen: closeModalActions.open,
};

export default connect(null, mapDispatchToProps)(Header);
